import type { JSX, PropsWithChildren } from 'react';

import { useLoadQueue } from './useLoadQueue';

export function FcmCacheQueueProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	useLoadQueue();

	return <>{children}</>;
}
